import React from 'react';
import { Skeleton } from 'antd';
import './style.css';

const LoadingSkeleton = ({ className }) => {
  return (
    <div className={`loading-skeleton-container ${className}`} style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <Skeleton.Input active className='skeleton-firts-portion' />
      <Skeleton.Input active className='skeleton-paragraph' />
      <Skeleton.Input active className='skeleton-firts-portion' />
    </div>
  );
};

export default LoadingSkeleton;
